import { createSlice } from '@reduxjs/toolkit';


export const domesticOverseasContactSlice = createSlice({
    name: 'domesticOverseasContact',
    initialState: {
        chooseName: 'domesticTitle',
    },
    reducers: {
        selectDomesticOverseasContact: (state, action) => {
            state.chooseName = action.payload.chooseName;
        }
    }
  });